export const messages = {
  en: {
    junkRequirement: {
      search: {
        title: 'Search Conditions',
        classification: 'Please select classification',
        publishUserName: 'Please enter publisher name',
        publishUserLink: 'Please enter contact information',
        state: 'Please select state'
      },
      list: {
        title: 'Junk Information'
      },
      table: {
        junkRequirementId: 'Code',
        classification: 'Classification',
        referencePrice: 'Reference Price',
        publishUserName: 'Publisher',
        publishUserLink: 'Contact',
        state: 'State'
      },
      edit: {
        title: 'Edit Junk',
        classification: 'Classification',
        context: 'Content',
        referencePrice: 'Reference Price',
        publishUserName: 'Publisher',
        publishUserLink: 'Contact',
        state: 'State',
        stateRequired: 'State is required',
        success: 'Review successful',
        error: 'Review failed'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to delete this junk?',
        success: 'Delete successful',
        error: 'Delete failed'
      },
      classification: {
        furniture: 'Furniture',
        appliance: 'Appliance'
      },
      state: {
        unreviewed: 'Unreviewed',
        reviewed: 'Reviewed',
        reviewFailed: 'Review Failed',
        completed: 'Completed'
      },
      fetchError: 'Failed to fetch junk requirements'
    },
  },
  zh: {
    junkRequirement: {
      search: {
        title: '查询条件',
        classification: '请选择类别',
        publishUserName: '请输入发布人',
        publishUserLink: '请输入联系方式',
        state: '请选择状态'
      },
      list: {
        title: '旧货信息'
      },
      table: {
        junkRequirementId: '编码',
        classification: '类别',
        referencePrice: '参考价格',
        publishUserName: '发布人',
        publishUserLink: '联系方式',
        state: '状态'
      },
      edit: {
        title: '修改旧货',
        classification: '类别',
        context: '内容',
        referencePrice: '参考价格',
        publishUserName: '发布人',
        publishUserLink: '联系方式',
        state: '状态',
        stateRequired: '状态不能为空',
        success: '审核成功',
        error: '审核失败'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定删除旧货吗？',
        success: '删除成功',
        error: '删除失败'
      },
      classification: {
        furniture: '家具',
        appliance: '电器'
      },
      state: {
        unreviewed: '未审核',
        reviewed: '审核通过',
        reviewFailed: '审核失败',
        completed: '处理完成'
      },
fetchError: '获取旧货需求失败'
    },
  },
  'zh-TW': {
    junkRequirement: {
      search: {
        title: '查詢條件',
        classification: '請選擇類別',
        publishUserName: '請輸入發佈人',
        publishUserLink: '請輸入聯繫方式',
        state: '請選擇狀態'
      },
      list: {
        title: '舊貨信息'
      },
      table: {
        junkRequirementId: '編碼',
        classification: '類別',
        referencePrice: '參考價格',
        publishUserName: '發佈人',
        publishUserLink: '聯繫方式',
        state: '狀態'
      },
      edit: {
        title: '修改舊貨',
        classification: '類別',
        context: '內容',
        referencePrice: '參考價格',
        publishUserName: '發佈人',
        publishUserLink: '聯繫方式',
        state: '狀態',
        stateRequired: '狀態不能為空',
        success: '審核成功',
        error: '審核失敗'
      },
      delete: {
        title: '請確認您的操作',
        confirm: '確定刪除舊貨嗎？',
        success: '刪除成功',
        error: '刪除失敗'
      },
      classification: {
        furniture: '家具',
        appliance: '電器'
      },
      state: {
        unreviewed: '未審核',
        reviewed: '審核通過',
        reviewFailed: '審核失敗',
        completed: '處理完成'
      },
      fetchError: '獲取舊貨需求失敗'
    },
  }
}